<template>
  <div class="title" v-if="titleRows && titleRows.length && columnNumber !== 0">
    <div
      class="text"
      @click="setSortingByColumn(columnNumber)"
    >
      <span>{{ titleRows[0] }}</span>
      <br>
      <span>{{ titleRows[1] }}</span>

      <img
        src="/static/images/elements/analytics/info.svg"
        alt="Info"
        v-tooltip="{
          content: tooltip,
          placement: 'auto',
          classes: 'tight'
        }">
    </div>
    <i v-if="sorting.numberColumn === columnNumber" class="fa" :class="sortingIcon"></i>
  </div>
  <span class="title" v-else @click="setSortingByColumn(columnNumber)">
    {{ title }}
    <i v-if="sorting.numberColumn === columnNumber" class="fa" :class="sortingIcon"></i>
  </span>
</template>

<script>
export default {
  name: 'recruiters-list-header-cell',

  props: {
    tooltip: String,
    columnNumber: Number,
    titleRows: Array,
    title: String
  },

  methods: {
    setSortingByColumn (columnNumber) {
      this.$emit('setSortingByColumn', columnNumber)
    }
  },

  computed: {
    sorting () {
      return this.$store.getters['analytics/recruiters/sorting']
    },

    sortingIcon () {
      return {
        'fa-caret-down': this.sorting.order === 'desc',
        'fa-caret-up': this.sorting.order === 'asc'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    display: flex;
    align-items: flex-start;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    font-size: 15px;
    letter-spacing: 0.005em;
    color: #607183;


    img {
      height: 12px;
      padding-top: 2px;
      margin-left: 3px;
      position: relative;
      top: 1px;

      &:hover { cursor: help; }
    }

    i {
      align-self: center;
    }
  }

  i {
    margin-left: 10px;
  }
</style>
